import { IsEnum, IsString, Length, IsDate, IsNotEmpty, MaxLength, IsOptional } from "class-validator";

import { IsCPF, IsBrPhone } from "./validation/customValidators";

export enum Gender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
}

export enum MaritalStatus {
  SINGLE = "SINGLE",
  MARRIED = "MARRIED",
  DIVORCED = "DIVORCED",
  WIDOWED = "WIDOWED",
  SEPARATED = "SEPARATED",
}

export class UserPersonalInfo {
	@MaxLength(100)
	@IsNotEmpty()
  name: string;

	@IsDate()
  birthDate: Date;

  @IsEnum(Gender)
  gender: Gender;

  @IsEnum(MaritalStatus)
  maritalStatus: MaritalStatus;

	@MaxLength(100)
	@IsNotEmpty()
  nationality: string;

	@MaxLength(100)
	@IsNotEmpty()
  citizenship: string;

  @IsCPF()
  cpf: string;

	@IsString()
	@Length(5, 14)
  rg: string;

	@MaxLength(100)
	@IsNotEmpty()
  rgIssuer: string;

	@IsDate()
  rgIssueDate: Date;

	@MaxLength(100)
	@IsNotEmpty()
  mothersName: string;

	@MaxLength(100)
	@IsNotEmpty()
  fathersName: string;

	@IsBrPhone()
  cellphoneNumber: string;

	@IsOptional()
	@IsBrPhone()
  landlineNumber: string;
}
